import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import EnrollmentService from "../../../_services/EnrollmentService";

interface InstrumentType {
  id: number;
  name: string;
  displayName: string;
  considerPaid: boolean;
  isDefault: boolean;
}

interface InstrumentTypeFieldsProps {
  instrumentTypeId: number | null;
  onInstrumentTypeChange: (id: number) => void;
  bankName: string;
  onBankNameChange: (v: string) => void;
  bankBranchName: string;
  onBankBranchNameChange: (v: string) => void;
  instrumentDate: string;
  onInstrumentDateChange: (v: string) => void;
  instrumentIdentifier: string;
  onInstrumentIdentifierChange: (v: string) => void;
}

/** Instrument type fields need bank/branch/cheque# only for non-cash types */
const NEEDS_BANK_DETAILS = ["CHEQUE", "CREDIT CARD", "Telegraphic Transfer"];
const NEEDS_IDENTIFIER = ["CHEQUE", "CREDIT CARD", "Telegraphic Transfer", "ONLINE", "ibanking"];

const InstrumentTypeFields: React.FC<InstrumentTypeFieldsProps> = ({
  instrumentTypeId,
  onInstrumentTypeChange,
  bankName,
  onBankNameChange,
  bankBranchName,
  onBankBranchNameChange,
  instrumentDate,
  onInstrumentDateChange,
  instrumentIdentifier,
  onInstrumentIdentifierChange,
}) => {
  const [types, setTypes] = useState<InstrumentType[]>([]);

  useEffect(() => {
    EnrollmentService.getInstrumentTypes()
      .then((res: any) => {
        if (res.data?.success) {
          setTypes(res.data.data);
          // Auto-select default if none selected
          if (!instrumentTypeId) {
            const def = res.data.data.find((t: InstrumentType) => t.isDefault);
            if (def) onInstrumentTypeChange(def.id);
          }
        }
      })
      .catch(console.error);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const selectedType = types.find((t) => t.id === instrumentTypeId);
  const showBank = selectedType && NEEDS_BANK_DETAILS.includes(selectedType.name);
  const showIdentifier = selectedType && NEEDS_IDENTIFIER.includes(selectedType.name);

  return (
    <>
      <Form.Group className="mb-2">
        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>
          Instrument Type
        </Form.Label>
        <Form.Select
          size="sm"
          value={instrumentTypeId || ""}
          onChange={(e) => onInstrumentTypeChange(Number(e.target.value))}
        >
          <option value="">-- Select --</option>
          {types.map((t) => (
            <option key={t.id} value={t.id}>
              {t.displayName}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {showBank && (
        <Row className="mb-2">
          <Col>
            <Form.Group>
              <Form.Label style={{ fontSize: 12 }}>Bank Name</Form.Label>
              <Form.Control
                size="sm"
                value={bankName}
                onChange={(e) => onBankNameChange(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label style={{ fontSize: 12 }}>Branch</Form.Label>
              <Form.Control
                size="sm"
                value={bankBranchName}
                onChange={(e) => onBankBranchNameChange(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      )}

      {showIdentifier && (
        <Row className="mb-2">
          <Col>
            <Form.Group>
              <Form.Label style={{ fontSize: 12 }}>
                Instrument Date
              </Form.Label>
              <Form.Control
                type="date"
                size="sm"
                value={instrumentDate}
                onChange={(e) => onInstrumentDateChange(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label style={{ fontSize: 12 }}>
                Cheque/Ref #
              </Form.Label>
              <Form.Control
                size="sm"
                value={instrumentIdentifier}
                onChange={(e) => onInstrumentIdentifierChange(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      )}
    </>
  );
};

export default InstrumentTypeFields;
